<form [formGroup]="form" (ngSubmit)="submit(form)">
  <div class="flex flex-row justify-center">
    <h4 class="text-lg font-bold">{{('#PORTAL_REGISTRATION.TITLE') | translate}}</h4>
  </div>
  <div class="flex flex-col mt-4">
    <label class="soft-label top required" for="registration-form-email">
      {{'#PORTAL_REGISTRATION.EMAIL' | translate}}
    </label>
    <soft-ds-input formControlName="email"
      id="registration-form-email"
      autocomplete="email"
    placeholder="{{'#PORTAL_REGISTRATION.EMAIL' | translate}}"> </soft-ds-input>
    @if (form.controls['email'].touched) {
      <soft-validation-container
        [validation]="form|validationMessage:'email'"
      class="soft-property-validation"></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-4">
    <label class="soft-label top required" for="registration-form-password">
      {{'#PORTAL_REGISTRATION.PASSWORD' | translate}}
    </label>
    <soft-ds-password-input formControlName="password"
      id="registration-form-password"
      autocomplete="new-password"
    placeholder="{{'#PORTAL_REGISTRATION.PASSWORD' | translate}}"></soft-ds-password-input>
    <soft-validation-container
      [validation]="form|validationMessage:'password'"
    class="soft-property-validation"></soft-validation-container>
  </div>
  <div class="flex flex-col mt-4">
    <label class="soft-label top required" for="registration-form-password-confirm">
      {{'#PORTAL_REGISTRATION.PASSWORD_CONFIRM' | translate}}
    </label>
    <soft-ds-password-input formControlName="passwordConfirm"
      id="registration-form-password-confirm"
      placeholder="{{'#PORTAL_REGISTRATION.PASSWORD_CONFIRM' | translate}}"
    autocomplete="new-password"></soft-ds-password-input>
    @if (form.controls['passwordConfirm'].touched) {
      <soft-validation-container
        [validation]="form|validationMessage:'passwordConfirm'"
      class="soft-property-validation"></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-4">
    <label class="soft-label top required" for="registration-form-first-name">
      {{'#PORTAL_REGISTRATION.FIRST_NAME' | translate}}
    </label>
    <soft-ds-input formControlName="firstName"
      id="registration-form-first-name"
      autocomplete="given-name"
    placeholder="{{'#PORTAL_REGISTRATION.FIRST_NAME' | translate}}"></soft-ds-input>
    @if (form.controls['firstName'].touched) {
      <soft-validation-container
        [validation]="form|validationMessage:'firstName'"
      class="soft-property-validation"></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-4">
    <label class="soft-label top required" for="registration-form-last-name">
      {{'#PORTAL_REGISTRATION.LAST_NAME' | translate}}
    </label>
    <soft-ds-input formControlName="lastName"
      id="registration-form-last-name"
      autocomplete="family-name"
    placeholder="{{'#PORTAL_REGISTRATION.LAST_NAME' | translate}}"></soft-ds-input>
    @if (form.controls['lastName'].touched) {
      <soft-validation-container
        [validation]="form|validationMessage:'lastName'"
      class="soft-property-validation"></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-4">
    <label class="soft-label top required" for="registration-form-company">
      {{'#PORTAL_REGISTRATION.COMPANY' | translate}}
    </label>
    <soft-ds-input formControlName="company"
      id="registration-form-company"
      placeholder="{{'#PORTAL_REGISTRATION.COMPANY' | translate}}"
    autocomplete="organization"></soft-ds-input>
    @if (form.controls['company'].touched) {
      <soft-validation-container
        [validation]="form|validationMessage:'company'"
      class="soft-property-validation"></soft-validation-container>
    }
  </div>
  <div class="flex flex-row mt-2">
    <re-captcha formControlName="captcha"></re-captcha>
  </div>

  <div class="flex flex-row justify-center mt-2">
    <button class="soft-button soft-button-primary"
      [disabled]="!(form | isValid) || isSubmitting"
    type="submit">{{'#PORTAL_REGISTRATION.SUBMIT' | translate}}</button>
  </div>
</form>
